import { apiFactory } from "../api_factory";

export const woundSeriesApi = apiFactory({
  path: `/api/v4/wound-series`
});
